import React, {PureComponent} from "react"
import gql from "graphql-tag"
import {ApolloQueryResult} from "apollo-client"

import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {RewardStatus} from "@irati/reward/enums"

import {RewardCatalogueRewards} from "../../types"
import RewardCatalogueProduct from "./fragments/RewardCatalogueProduct"

export interface RewardCatalogueRewardVariables {
  limit: number
  offset: number
  q: string | null
  status: string
  locale?: string
  rewardsForMyPackage?: boolean
}

interface Data {
  rewardCatalogueRewards: RewardCatalogueRewards
}

export type RewardCatalogueRewardData = ApolloQueryResult<Data>

const query = gql`
  query RewardCatalogueRewards($limit: Int, $q: String, $offset: Int, $status: String, $locale: String, $rewardsForMyPackage: Boolean) {
    rewardCatalogueRewards(
      limit: $limit
      q: $q
      offset: $offset
      status: $status
      locale: $locale
      rewardsForMyPackage: $rewardsForMyPackage
    ) {
      count
      limit
      offset
      total
      results {
        uuid
        archived
        internalIdentifier
        urlSlug
        status
        header
        description
        importantInfo
        deliveryInfo
        redemptionInstructions
        termsAndConditions
        bannerImage
        cardImage
        thumbnailImage
        keywords
        locale
        country
        products {
          count
          total
          results {
            ...RewardCatalogueProduct
          }
        }
        tags {
          uuid
          name
        }
      }
    }
  }
  ${RewardCatalogueProduct}
`

export const variables = {
  limit: 20,
  offset: 0,
  q: null,
  status: RewardStatus.ON
}

interface Props {
  variables?: RewardCatalogueRewardVariables
}

export default class RewardCatalogueRewardsQuery extends PureComponent<Props> {
  static defaultProps = {
    variables
  }

  render() {
    return <QueryComponent query={query} {...this.props} />
  }
}
